// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1As04","icon":"styles_icon__1ep2C","label":"styles_label__1BuK1"};